export class User {
  serverId: Number;
  firstName: string;
  lastName: string;
  location: string;
  username: string;
  password: string;
  email: string;
  country: string;
  state: string;
  gender: string;
  mobilePhone: string;
  officePhone: string;
  address: string;
  zip: string;
  clinicianRoleId: string;
  clinicianRoleName: string;
  isPasswordUpdated: boolean;
  encryptedServerId: String;
  businessName: String;
  businessId: number;
  workstationName: String;
  workstationId: number;
  workstationCode: String;
  businessCode: String;
}

export class newUser {
  id: number;
  userName: string;
  password: string;
  canLogin?: boolean;
  markAsDeleted?: string;
  tokenExpirationTime?: Date;
  systemGeneratedPassword?: string;
  isRecoveryEmailSent?: boolean;
  tempPasswordCreationTime?: Date;
  passwordLastUpdatedOn?: string;
  lastModifiedUtcTime?: string;
  serverId: number;
  firstName: string;
  isActiveUser: boolean;
  middleName: string;
  lastName: string;
  nickName: string;
  isTestPatient: boolean;
  mobilePhone: string;
  email: string;
  sex: number;
  dob: Date;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  clinicianRoleId: number;
  clinicianRoleName: string;
  businessType: number;
  loggedInUserID: string;
  primaryID?: string;
  secondaryID?: string;
  workstationId: number;
  businessId: number;
  locationId: number;
  applicationLookup: number;
  localDateTime?: Date;
  utcDateTime?: Date;
  encryptedServerId: String;
  workstationName: string;
}
